<template>
  <div class="yulan-info" :class="$route.query.themeStyleVs == 2 ? 'black_theme' : 'white_theme'">
    <div v-if="!is304">
      <div class="vanEmpty" v-if="loading">
        <div>
          <van-empty description="数据加载中..." :image="require('@/assets/image/notData.png')" />
        </div>
      </div>

      <div class="header-bg" v-else>
        <van-sticky z-index="100">
          <div
            ref="contentNavBarRef"
            class="content-nav-bar"
            :class="bodyOffsetTop <= contentNavBarHeight ? 'sticky-header' : ''"
            :style="`backdrop-filter: blur(${filterNum}px)`"
          >
            <van-nav-bar title="多因子策略回测详情">
              <template #left>
                <van-icon
                  :name="shareType === 'true' ? 'cross' : 'arrow-left'"
                  size="18"
                  @click="goBack"
                />
              </template>
              <template #right>
                <img
                  v-if="isHc && compareVersions($route.query.version,9.68)"
                  :src="$route.query.themeStyleVs == 2 ? blackShare : shareImg"
                  @click="shareBtnFn"
                  alt=""
                />
              </template>
            </van-nav-bar>
          </div>
        </van-sticky>

        <div class="yulan-content">
          <div class="header">
            <div class="title">
              <p class="name">多因子策略回测</p>

              <button class="edit vip-parent" @click="goEdit" v-if="isHc">
                编辑 <i class="vip-icon" v-show="!isVip && vipIcon"></i>
              </button>
            </div>
          </div>

          <div class="collapse" v-if="isHc">
            <FactorDetailModal
                            :collection_condition="collection_condition"
                        ></FactorDetailModal>
          </div>

          <div class="btm-style" ref="body">
            <div ref="tabs">
              <van-sticky :offset-top="contentNavBarHeight - 2" z-index="99">
                <van-tabs v-model="active" @change="handleClickTabs">
                  <van-tab title="评级报告"></van-tab>
                  <van-tab title="回测分析"></van-tab>
                  <van-tab title="历史明细"></van-tab>
                </van-tabs>
              </van-sticky>
            </div>

            <div id="section1" ref="section1">
              <DyzPjbg
                :ReportGradeResult="Obj.apiData.ReportGradeResult"
                :startDate="Obj.startDate"
                :endDate="Obj.endDate"
              ></DyzPjbg>
            </div>

            <p
              style="background: #f8f9fc; height: 8px"
              :style="$route.query.themeStyleVs == 2 ? 'background:#0B0F14' : ''"
            ></p>

            <div id="section2" ref="section2">
              <DyzHcfx
                :tabsHeight="tabsHeight"
                :headerHeight="contentNavBarHeight"
                :BacktestAnalysisResult="Obj.apiData.BacktestAnalysisResult"
                :holdPeriodList="Obj.holdPeriodList"
              ></DyzHcfx>
            </div>

            <p
              style="background: #f8f9fc; height: 8px"
              :style="$route.query.themeStyleVs == 2 ? 'background:#0B0F14' : ''"
            ></p>

            <div id="section3" ref="section3">
              <DyzLsmx
                :Obj="Obj"
                :tabsHeight="tabsHeight"
                :headerHeight="contentNavBarHeight"
              ></DyzLsmx>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 没有慧豆时页面显示 -->
    <NotHd v-else></NotHd>

    <!-- vip弹窗 -->
    <vipInfo :show="vipShow"></vipInfo>
  </div>
</template>

<script>
import { factorArrCheckoutFun } from '@/utils/commonAPI';
import mixin from '@/mixins/index.js';
import DyzPjbg from '@/components/details/DyzPjbg.vue';
import DyzHcfx from '@/components/details/DyzHcfx.vue';
import DyzLsmx from '@/components/details/DyzLsmx.vue';
import { getFactorHq } from '@/api/create';
import NotHd from '@/components/notHd/notHd.vue';
import { getDyzHcById } from '@/api/details';
import { setShareById } from '@/api/index.js';
import VueScrollTo from 'vue-scrollto';
import { mapMutations } from 'vuex';
import vipInfo from '@/components/diaLog/vipInfo.vue';
import { compareVersions,parseCollectionCondition } from '@/utils/format.js';
export default {
  name: 'Dyz-details',
  mixins: [mixin],
  data() {
    return {
      shareImg: require('../../assets/image/share_btn.png'),
      blackShare: require('../../assets/image/blockImg/share_img.png'),
      contentNavBarHeight: 93,
      is304: false,
      loading: true,
      num: 2,
      active: 0,
      filterNum: 0,
      tabsHeight: 0,
      bodyOffsetTop: 0,
      showoVerlay: false,
      scrollTop: 0,
      section1: 0,
      section2: 0,
      section3: 0,
      timeoutId: null, // 添加 timeoutId 属性，用于存储 setTimeout 的返回值
      f_id_arr: '',
      isHc: false,
      shareType: 'false',
      // VIP标志
      isVip: false,
      vipIcon: true, //vipIcon
      vipShow: false,
      conditionInfo: {},
      collection_condition: {}
    };
  },
  components: {
    DyzPjbg,
    DyzHcfx,
    DyzLsmx,
    NotHd,
    vipInfo
  },
  filters: {},
  //计算属性
  computed: {
    checkedYzList: function () {
      return this.$store.state.checkedYzList; // 获取全局状态
    },
    Obj: function () {
      return this.$store.state.Obj; // 获取全局状态
    },
    contentNavBar: function () {
      return this.$store.state.contentNavBar; // 获取全局状态
    },
    publicHcID: function () {
      return this.$store.state.publicHcID; // 获取vuex的id 要是存在id走编辑逻辑
    },
    type: function () {
      return this.$store.state.type; // 来判断是保存策略还是更新
    },
    btnDisabled: function () {
      return this.$store.state.btnDisabled; // 用来控制回测是变灰还是现实更新
    }
  },
  watch: {
    '$store.state.isVip': {
      handler(newValue) {
        this.isVip = newValue;
      },
      immediate: true // 立即执行一次
    },
    showoVerlay: function (i) {
      if (i) {
        this.clName = this.Obj.name || '';
        this.clDetails = this.Obj.desc || '';
      } else {
        this.clName = '';
        this.clDetails = '';
      }
    }
  },
  created() {
    this.shareType = this.getUrlQuery('shareType');
    this.$nextTick(function () {
      if (compareVersions(this.$route.query.version , 9.71)) {
        this.vipIcon = true;
      } else {
        this.vipIcon = false;
      }
    });
  },
  async mounted() {
    await this.getDyzHcByIdFun();
    this.clName = this.Obj.name || '';
    this.clDetails = this.Obj.desc || '';

    var navHeight = this.$refs.contentNavBarRef.offsetHeight;
    this.contentNavBarHeight = navHeight;

    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('scroll', this.handleScrollTab);

    //获取评级报告和回测分析的高度
    var contentTabs = this.$refs['tabs'];
    this.tabsHeight = contentTabs.offsetHeight;

    this.bodyOffsetTop = this.$refs.body.getBoundingClientRect().top;
    this.section1 = this.$refs.section1.getBoundingClientRect().top;
    this.section2 = this.$refs.section2.getBoundingClientRect().top;
    this.section3 = this.$refs.section3.getBoundingClientRect().top;
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('scroll', this.handleScrollTab);
  },
  methods: {
    compareVersions,
    ...mapMutations(['resetState']),

    //监听ref=body的滚滚动条距离用来控制header的背景色显示隐藏
    handleScroll() {
      this.scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      this.bodyOffsetTop = this.$refs.body.getBoundingClientRect().top;
      this.filterNum = (this.scrollTop / (this.bodyOffsetTop / 2)).toFixed(2);
    },

    handleScrollTab() {
      if (this.$refs.section1.getBoundingClientRect().top <= this.tabsHeight + this.contentNavBar) {
        this.active = 0;
      }
      if (this.$refs.section2.getBoundingClientRect().top <= this.tabsHeight + this.contentNavBar) {
        this.active = 1;
      }
      if (this.$refs.section3.getBoundingClientRect().top <= this.tabsHeight + this.contentNavBar) {
        this.active = 2;
      }
    },

    scrollToSection(sectionId) {
      VueScrollTo.scrollTo(`#${sectionId}`, 500, {
        offset: -120 // 调整偏移量以适应您的布局
      });
    },

    //手动点击切换的时候清除监听 然后1s之后再次恢复防止滚动和手动点击冲突
    handleClickTabs: function (i) {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      } else {
        window.removeEventListener('scroll', this.handleScrollTab);
      }

      if (i === 0) {
        this.scrollToSection('section1');
      } else if (i === 1) {
        this.scrollToSection('section2');
      } else if (i === 2) {
        this.scrollToSection('section3');
      }

      this.timeoutId = setTimeout(() => {
        window.addEventListener('scroll', this.handleScrollTab);
        this.timeoutId = null;
      }, 1500);
    },

    handleClickShowAll: function () {
      if (this.num === 2) {
        this.num = this.checkedYzList.length;
      } else {
        this.num = 2;
      }
    },

    //根据h_id获取回测详情
    getDyzHcByIdFun: function () {
      this.loading = true;
      var params = {
        h_id: this.$route.query.h_id
      };
      return getDyzHcById(params)
        .then((res) => {
          this.loading = false;

          if (res.err === 200) {
            this.f_id_arr = res.data.condition.f_id_arr;
            this.isHc = res.data.condition.isHc;

            // 赋值因子组合
            this.collection_condition = JSON.parse(
                res.data.condition.collection_condition
            );

            var Obj = {
              holdPeriodList: res.data.condition.chigu_cycle, //string 持股周期: 1,2,3,4,5,6
              startDate: res.data.condition.starDate, //string 开始时间 : 20220101
              endDate: res.data.condition.endDate, //string 结束时间 : 20230101
              isCustomSelected: res.data.condition.chigu_type === 1 ? true : false, //持股类型 : 0默认 1自定义 2固定
              apiData: res.data,
              type_info: res.data.condition.type_info, //因子类型 1A股 2etf
              isEdit: true
            };
            this.$store.commit('setObj', Obj);
            this.$store.commit('setPublicHcID', res.data.condition.h_id);
            this.conditionInfo = res.data.condition;
            this.reportShence();
          } else if (res.err === 304) {
            this.is304 = true;
            window.location.href = window.config.hdTips;
          } else if (res.err === 305) {
            this.$toast('功能使用异常，请检查您的登录状态');
          }
        })
        .catch((err) => {
          this.loading = false;
          // this.$toast(err);
        });
    },
    //行情
    getFactorHqFun: function (yzIds) {
      var params = {
        type: 'yz',
        factorID: yzIds,
        field: 'Desc,KanDian,FactorCode,XiFenZhongLei'
      };
      return getFactorHq(params)
        .then((res) => {
          this.$store.commit('setCheckedYzList', res.data);
        })
        .catch((err) => {
          this.$toast(err);
        });
    },

    //点击去编辑
    goEdit: function () {
      if(this.isVip == false && compareVersions(this.$route.query.version , 9.92)) {
        let appJson = {
          DialogType: "basic",
        };
        DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc(
          'factorTYPerDialog',
          JSON.stringify(appJson),
          ''
        );
        return false;
      } else if (this.isVip == false && compareVersions(this.$route.query.version , 9.71)) {
        // 如果不是VIP用户,弹出VIP提示
        //  this.vipShow = true;
        // 调用客户端js 弹窗
        // 多因子回测编辑-JSON
        let appJson = {
          channel: 'yinzi',
          dzhadid: '0709',
          sourcecode: '3509',
          mediaID: '0709'
        };
        DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc(
          'factorNoVipPerDialog',
          JSON.stringify(appJson),
          ''
        );
        return false;
      }

      var ctype = JSON.parse(this.Obj.apiData.condition.collection_condition);

      var fIdArrToStr = parseCollectionCondition(ctype.yzList, ctype.children);



      let msg = [];
      factorArrCheckoutFun(this.f_id_arr).then((d) => {
        if (d.length > 0) {
          d.forEach((i) => {
            if (i.BacktestType == 2 || i.BacktestType == 3) {
              msg.push(i.Name + '(不可回测)');
            } else if (i.BacktestType == 10) {
              msg.push(i.Name + '(已删除)');
            }
          });

          this.$toast('编辑参数失败:' + msg.toString());
        } else {
          this.$store.commit('setType', 'source_dyzhcDetails');

          let source = '';
          if (this.$route.query.source == 'appDyzHc' || !this.$route.query.source) {
            source = 'appDyzHc';
          } else {
            source = 'dyzcl';
          }

        // 插入因子组合
        this.$store.commit('setCheckedYzType', ctype.composeType);
        this.$store.commit('setCheckedYzList', ctype.yzList);
        this.$store.commit('setGroupYzList', ctype.children);

          this.$router.push({
            path: '/checkedYz',
            name: 'CheckedYz',
            query: {
              source: source, //用来标注是从多因子还是量化过去的 app开头的事客户端跳转过来的
              token: this.$route.query.token || '',
              mySource: 'myDyzHc', //用来标注是从个人中心过去的
              themeStyleVs: this.$route.query.themeStyleVs || 0,
              version: this.$route.query.version || '',
              yzType: this.conditionInfo.type_info == 2 ? 'ETF' : 'A'
            }
          });
        }
      });
    },

    //返回
    goBack: function () {
      if (this.shareType === 'true' || compareVersions(this.$route.query.version , 9.73)) {
        location.href = 'dzh_browser_url&goto=0&screen=263';
      } else {
        if (
          (this.$route.query.tab === 'hc' && this.$route.query.smallTab === 0) ||
          this.$route.query.mySource == 'myDyzHc'
        ) {
          this.$router.push({
            path: '/my',
            name: 'My',
            query: {
              token: this.$route.query.token || '',
              tab: 'hc',
              smallTab: 0,
              themeStyleVs: this.$route.query.themeStyleVs || 0,
              version: this.$route.query.version
            }
          });
        } else {
          this.$router.go(-1);
        }
      }
    },
    // 分享
    shareBtnFn: function () {
      let that = this;
      setShareById({}).then((res) => {
        if (res.err === 200) {
          let obj = {
            id: that.$route.query.h_id,
            type: 3,
            sid: res.data
          };
          let urlLink = encodeURIComponent(
            window.config.shareLink +
              '?DZHSPECIAL=256&sid=' +
              res.data +
              '&type=3&id=' +
              that.$route.query.h_id
          );
          if (/android/i.test(navigator.userAgent)) {
            urlLink = encodeURIComponent(urlLink);
          }
          window.location.href =
            'dzh_browser_url&goto=0&screen=470&title=我在大智慧因子投研平台发现了一个多因子策略回测，一起来看看吧！&text=因子投研平台&url=' +
            urlLink +
            '&icon=' +
            window.config.shareLogo +
            '&ext=' +
            JSON.stringify(obj);
        }
      });
    },
    // 上报神策
    reportShence: function () {
      if (
        this.conditionInfo.collection_condition &&
        this.conditionInfo.collection_condition !== null &&
        this.conditionInfo.collection_condition !== 'null'
      ) {
        let jsonArray = JSON.parse(this.conditionInfo.collection_condition);
        // 判断 yzList 是否为空
        if (jsonArray.yzList.length > 0) {
          jsonArray.yzList.forEach((element) => {
            // 如果是普通因子就上报
            if (element.yzType == 0) {
              console.log('上报成功', {
                factor_id: element.ID,
                operate_type: 'back_test',
                platform: 'Web-App'
              });
              sensors.track('factor_click', {
                factor_id: element.ID,
                operate_type: 'back_test',
                platform: 'Web-App'
              });
            }
          });
        }
        // 判断 children 是否为空
        if (jsonArray.children.length > 0) {
          jsonArray.children.forEach((element) => {
            element.forEach((element2) => {
              console.log('上报成功', {
                factor_id: element2.ID,
                operate_type: 'back_test',
                platform: 'Web-App'
              });
              sensors.track('factor_click', {
                factor_id: element2.ID,
                operate_type: 'back_test',
                platform: 'Web-App'
              });
            });
          });
        }
      }
    },
    // 点击因子跳转详情
    gotoFactorDetail:function (item) {
      console.log('item',item)
      if(item.yzType === 0) {
        // 正常的因子 走功能号
        window.location.href = 'dzh_browser_url&goto=0&screen=464&factorid='+item.ID+'&factorname='+item.FactorName;
      } else {
        // 走因子详情
        location.href = '/zdyfactors?DZHSPECIAL=4325641&fid=' + item.ID;
      }
    }
  }
};
</script>
<style lang="less" scoped>
.yulan-info {
  -webkit-overflow-scrolling: touch;
  .vanEmpty {
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .header-bg {
    height: 100vh;
    img {
      width: 24px;
      height: 24px;
    }
  }

  .header {
    padding: 20px 16px;
    .title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .name {
        font-weight: 500;
        font-size: 20px;
        color: #222;
      }
      .edit {
        width: 60px;
        height: 30px;
        background: #286df7;
        border-radius: 4px;
        font-weight: 500;
        font-size: 14px;
        color: #fff;
      }
    }
  }
  .collapse {
    padding: 0 16px 22px 16px;
    .title {
      font-weight: 700;
      font-size: 14px;
      color: #286df7;
    }
    .yz-list {
      .li {
        height: 34px;
        line-height: 34px;
        border: 1px solid #fff;
        border-radius: 4px;
        background: linear-gradient(to bottom right, #e6edff 10%, #fff 60%);
        padding: 0 12px;
        margin-top: 6px;
        font-weight: 500;
        font-size: 12px;
        color: rgba(55, 58, 77, 0.9);
        overflow: hidden; //超出的文本隐藏
        text-overflow: ellipsis; //溢出用省略号显示
        display: -webkit-box;
        -webkit-line-clamp: 1; // 超出多少行
        -webkit-box-orient: vertical;
      }
    }
  }
  .btm-style {
    border-radius: 8px 8px 0 0;
    background: #fff;
    padding-bottom: 20px;
  }
  .yulan-content {
    .van-tabs {
      border-radius: 8px 8px 0 0;
      overflow: hidden;
    }
    ::v-deep {
      .van-tab {
        font-weight: 400;
        font-size: 14px;
        color: #373a4d;
      }
      .van-tab--active {
        font-weight: 600 !important;
        font-size: 14px !important;
        color: #286df7 !important;
      }
      .van-tabs__line {
        background: #286df7;
      }
    }
  }
}
</style>

<!-- 黑色主题 -->
<style lang="less" scoped>
.black_theme {
  .vanEmpty {
    background: #191a24;
  }
  .yulan-content {
    .name,
    .title {
      color: #e4e9fe !important;
    }
    .yz-list {
      .li {
        border: 1px solid rgba(255, 255, 255, 0.1);
        background: rgba(255, 255, 255, 0.1);
        color: #e4e9fe;
      }
    }
    ::v-deep {
      .btm-style,
      .van-tabs__nav {
        background: #191a24;
      }
      .van-tab {
        color: #e4e9fe;
      }
    }
  }
  .wrapper-overlay {
    background: #181a23 !important;
    .wrapper-title {
      color: #e4e9fe !important;
    }
    .wrapper-label {
      color: #aab9d1 !important;
    }
    .van-cell {
      background: none;
      border: 1px solid #3b3d43 !important;
    }
    ::v-deep {
      .van-field__control {
        color: #e4e9fe !important;
      }
    }
    .wrapper-btn {
      .left {
        background: #46484f;
        color: #aab9d1;
      }
    }
  }
}
</style>
